import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

// Single icon button matching the llc-automation navbar toggle: shows a sun in
// light mode / a moon in dark mode, and flips light <-> dark on click based on
// what's actually showing. Inline outline SVGs, no icon dependency.

const SunIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden
  >
    <circle cx='12' cy='12' r='3.75' />
    <path d='M12 3v2.25M12 18.75V21M5.25 12H3M21 12h-2.25M5.636 5.636l1.591 1.591M16.773 16.773l1.591 1.591M18.364 5.636l-1.591 1.591M7.227 16.773l-1.591 1.591' />
  </svg>
);

const MoonIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden
  >
    <path d='M21.75 15a9.75 9.75 0 11-9.75-12.75A7.5 7.5 0 0021.75 15z' />
  </svg>
);

export const ThemeToggle: React.FC = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className='inline-flex items-center justify-center rounded-md p-2 text-on-surface-secondary transition-colors hover:bg-surface-tertiary hover:text-on-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary'
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <MoonIcon className='h-5 w-5' /> : <SunIcon className='h-5 w-5' />}
    </button>
  );
};
